// API configuration
// Priority: 1. Environment variable, 2. Localhost detection, 3. Relative URLs
const API_URL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5001'
    : '');

export default API_URL;
